<section class="technologies" id="technologies">
  <div class="technologies__content">
    <h2>{{ 'TECHNOLOGIES.TITLE' | translate }}</h2>
    <p>{{ 'TECHNOLOGIES.TEXT' | translate }}</p>

    <div class="tech-grid">
      @for (tech of 'TECHNOLOGIES.LIST' | translate; track tech; let i = $index) {
        <span>{{ tech }}</span>
      }
    </div>
  </div>
</section>
